import React, { useState } from "react";
import axios from "axios";


const useFormulaType = ({
    onFinish = () => { }, //{ axiosMode, status, values }
    onBefore = () => { }, //{ axiosMode, status }
}) => {
    const mainApi = `/Salary/TYPE_Formula`
    const [data, setData] = useState([])
    const [option, setOption] = useState([])
    const getFormulaTypeOption = ({iFormulaType,cName}) => {
        axios.get(mainApi, {
            params: {
                iFormulaType:iFormulaType,
                cName:cName
            },
        })
            .then((response) => {
                let data = response.data.data
                console.log({data})
                setOption((pre) => {
                    return data.map((value) => {
                        return {
                            ...value,
                            label: value?.cName,
                            value: value?.iFormulaType
                        }
                    })
                })
            });
    }
    const getFormulaTypeData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postFormulaTypeData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchFormulaTypeData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteFormulaTypeData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        FormulaTypeData: data,
        FormulaTypeOption: option,
        getFormulaTypeOption,
        getFormulaTypeData,
        postFormulaTypeData,
        patchFormulaTypeData,
        deleteFormulaTypeData
    }
}
export { useFormulaType }
